"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorySearch = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const table_1 = require("client/components/material/table");
const table_row_1 = require("client/components/material/table/table-row");
const floating_page_1 = require("client/components/page/floating-page");
const alert_1 = require("client/components/ui/alert");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/inventory/modules/inventory-search/store");
const store_2 = require("client/modules/users/store");
const Search_1 = require("material-ui-icons/Search");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
require("./inventory-search.less");
const columns = [
    {
        center: false,
        id: "priceType",
        numeric: false,
        label: "Price Type"
    },
    {
        center: false,
        id: "priceDesc",
        numeric: false,
        label: "Description"
    },
    {
        center: false,
        id: "price",
        numeric: true,
        label: "Price"
    },
    {
        center: false,
        id: "qty",
        numeric: true,
        label: "Quantity"
    },
    {
        center: false,
        id: "uom",
        numeric: false,
        label: "Unit of Measure"
    },
    {
        center: false,
        id: "date",
        numeric: false,
        label: "Effective Date"
    }
];
let InventorySearch = class InventorySearch extends react_1.Component {
    constructor() {
        super(...arguments);
        this.productwithPackage = {};
        this.selectedPackage = {};
        this.order = "ASC";
        this.orderBy = "name";
        this.filterText = "";
        this.handleInputChange = throttle_debounce_1.debounce(500, (value) => {
            if (value === "")
                return;
            store_1.inventorySearchStore.loadFTS(value.toLowerCase());
        });
        // public handleSubmit = async () => {
        // };
        this.handleSelect = async (value) => {
            const data = await store_1.inventorySearchStore.loadFTS(value, "single");
            this.selectedPackage = store_1.inventorySearchStore.fdb[0] || {};
            console.log(this.selectedPackage);
        };
        this.renderTableRow = (row, index) => row && (React.createElement(table_row_1.MaterialTableRow, { key: index },
            React.createElement(Table_1.TableCell, null, row.PriceType || ""),
            React.createElement(Table_1.TableCell, null, row.PriceTypeDescription || ""),
            React.createElement(Table_1.TableCell, null, row.Price || ""),
            React.createElement(Table_1.TableCell, null, row.Quantity || ""),
            React.createElement(Table_1.TableCell, null, row.UOM || ""),
            React.createElement(Table_1.TableCell, null, moment(row.EffectiveDate).format("MM/DD/YYYY") || "")));
        this.renderTable = (data) => (React.createElement("div", { className: "package-data__price-table" },
            React.createElement(table_1.MaterialTable, { clickable: true, columns: columns, 
                // onRequestSort={this.onRequestSort}
                order: this.order, orderBy: this.orderBy, rows: data, renderRow: this.renderTableRow })));
    }
    get availableOptions() {
        const a = store_1.inventorySearchStore.fdb;
        return a
            ? a.map((pkg, i) => {
                const pkgName = pkg.LabelName;
                const ndc = pkg.NDC;
                const index = pkg.index;
                return {
                    id: i,
                    label: `${pkgName} - ${ndc}`,
                    value: `${index}`
                };
            })
            : [];
    }
    async componentDidMount() {
        await store_1.inventorySearchStore.loadFTS("");
        const urlParams = new URLSearchParams(document.location.search);
        if (urlParams.has("ndc")) {
            const ndc = urlParams.get("ndc");
            const data = await store_1.inventorySearchStore.loadFTS(ndc, "single");
            this.selectedPackage = store_1.inventorySearchStore.fdb[0] || {};
        }
    }
    renderData() {
        const pkg = Object.assign({}, this.selectedPackage) || {};
        const pkgLoaded = Object.entries(pkg).length > 0;
        const noSearch = (React.createElement("div", { className: "package-data__no-search" },
            React.createElement("div", { className: "package-data__animated--hover" },
                React.createElement(Search_1.default, null)),
            React.createElement("div", { className: "package-data__shadow" }),
            React.createElement("p", null, "Enter a keyword, NDC number, or unique identifier.")));
        if (!pkgLoaded)
            return noSearch;
        /** Remove nulls from objects, delete if they're empty. */
        const cleanObj = (value) => {
            pkg[value] = pkg[value].filter(e => e);
            if (pkg[value].length === 0)
                delete pkg[value];
        };
        if (!!pkg.CurrentPrice)
            cleanObj("CurrentPrice");
        const headers = [
            "Generic",
            "LabelName",
            "Manufacturer",
            "MedicalDescription"
        ];
        const blocks = ["CurrentPrice", "Notes", "WarningLabels"];
        const data = (React.createElement("div", { className: "package-data" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "package-data__header package-data--title" },
                    React.createElement("h2", null, !!pkg.LabelName && pkg.LabelName),
                    React.createElement("ul", { className: "package-data--small package-data--body" },
                        !!pkg.NDC && (React.createElement("li", null,
                            React.createElement("b", null, "NDC:"),
                            " ",
                            pkg.NDC)),
                        !!pkg.Manufacturer && (React.createElement("li", null,
                            React.createElement("b", null, "Manufacturer:"),
                            " ",
                            pkg.Manufacturer)),
                        !!pkg.Generic && (React.createElement("li", null,
                            React.createElement("b", null, "Generic:"),
                            " ",
                            pkg.Generic,
                            " (",
                            pkg.GenericID,
                            ")")),
                        !!pkg.MedicalDescription && (React.createElement("li", null,
                            React.createElement("b", null, "Description:"),
                            " ",
                            pkg.MedicalDescription))))),
            React.createElement("div", { className: "row--flex" },
                React.createElement("div", { className: "package-data__info" },
                    React.createElement("span", { className: "package-data--subheader" }, "Package Information"),
                    React.createElement("ul", { className: "package-data--small" }, Object.entries(pkg)
                        .sort()
                        .map((e) => {
                        const key = e[0];
                        let value = e[1];
                        if (headers.includes(key) ||
                            blocks.includes(key) ||
                            value.length === 0 ||
                            key === "index")
                            return;
                        if (typeof value !== "string") {
                            try {
                                value = value.join(", ");
                            }
                            catch (err) {
                                /* I've only seen one double-nested object so far,
                              but this should be refactored to support multiple nesting. **/
                                Object.entries(value).forEach(v => {
                                    value = `${v[0]}: ${Object.values(v[1]).join(", ")}`;
                                });
                            }
                        }
                        return (React.createElement("li", null,
                            React.createElement("b", null,
                                key,
                                ":"),
                            " ",
                            value));
                    }))),
                !!pkg.WarningLabels && (React.createElement("div", { className: "package-data__warnings" },
                    React.createElement("span", { className: "package-data--subheader" }, "Warning Labels"),
                    React.createElement("ul", { className: "package-data--small" }, Object.entries(pkg.WarningLabels).map((e) => (React.createElement("li", { className: "package-data--note" },
                        "\u2022 ",
                        e[1]))))))),
            React.createElement("div", { className: "row" }, !!pkg.CurrentPrice && (React.createElement("div", { className: "package-data__prices" },
                React.createElement("span", { className: "package-data--subheader" }, "Current Prices"),
                this.renderTable(pkg.CurrentPrice)))),
            React.createElement("div", { className: "row" }, !!pkg.Notes && (React.createElement("div", { className: "package-data__notes" },
                React.createElement("span", { className: "package-data--subheader" }, "Notes"),
                React.createElement("ul", { className: "package-data--small" }, Object.entries(pkg.Notes).map((e) => (React.createElement("li", { className: "package-data--note" },
                    React.createElement("b", null,
                        e[0],
                        ":"),
                    " ",
                    e[1].replace(/^.+\:/, ""))))))))));
        return data;
    }
    render() {
        const urlParams = new URLSearchParams(document.location.search);
        const pkgNotFound = urlParams.has("ndc") && Object.entries(this.selectedPackage).length === 0;
        const unavailable = () => (React.createElement(alert_1.UiAlert, { title: "Not Found", type: "warning", message: `NDC "${urlParams.get("ndc")}" is not listed in First Data Bank.` }));
        return (React.createElement("div", { className: "inventory" }, store_2.usersStore.permissions.CreateFormulary ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "First Databank Lookup" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                (pkgNotFound && unavailable()) || "",
                React.createElement("div", { className: "inventory__form" },
                    React.createElement("div", { className: "create-form" },
                        React.createElement(select_1.MaterialSelect, { label: "Search for NDC Package", options: this.availableOptions, searchable: true, onInputChange: this.handleInputChange, onSelect: this.handleSelect, value: this.selectedPackage.index || "" }),
                        React.createElement(button_1.MaterialButton, { onClick: () => {
                                this.selectedPackage = {};
                                store_1.inventorySearchStore.loadFTS("");
                            } }, "Clear")),
                    React.createElement("p", { style: { textAlign: "center" } }, "NDCs must be entered without dashes."),
                    React.createElement("div", { className: "inventory__form__description", style: { marginTop: "20px" } },
                        React.createElement("div", { className: "flexContainer" }),
                        store_1.inventorySearchStore.loading ? React.createElement(loading_indicator_1.UiLoadingIndicator, null) : "",
                        this.renderData()))))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.computed
], InventorySearch.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], InventorySearch.prototype, "productwithPackage", void 0);
__decorate([
    mobx_1.observable
], InventorySearch.prototype, "selectedPackage", void 0);
__decorate([
    mobx_1.observable
], InventorySearch.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], InventorySearch.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], InventorySearch.prototype, "filterText", void 0);
InventorySearch = __decorate([
    mobx_react_1.observer
], InventorySearch);
exports.InventorySearch = InventorySearch;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-search/inventory-search.tsx
// module id = 3502
// module chunks = 0